const FIRST_WAITING_TIME_PERIOD = ["1:35", "1:55", "2:15", "2:35", "2:55"];
const SECOND_WAITING_TIME_PERIOD = ["0:35", "0:55", "1:15", "1:35", "1:55"];
const FIRST_DROPOFF_TIME_PERIOD = ["2:20", "2:40", "3:00", "3:20", "3:40"];
const SECOND_DROPOFF_TIME_PERIOD = ["1:20", "1:40", "2:00", "2:20", "2:40"];

export {
  FIRST_WAITING_TIME_PERIOD,
  SECOND_WAITING_TIME_PERIOD,
  FIRST_DROPOFF_TIME_PERIOD,
  SECOND_DROPOFF_TIME_PERIOD
};